export const ADVERTISER_CONDITIONS_TRANSLATIONS = {
  welcome_bonus: {
    label: $localize`:@@advertiser.welcome_bonus:Welcome Bonus`,
    tooltip: $localize`:@@advertiser.welcome_bonus_tooltip:25/75 means "deposit 25 EUR, play with 75 EUR (bonus amount 50 EUR)" - promotion 200% up to 50 EUR`,
  },
  free_chips: {
    label: $localize`:@@advertiser.free_chips:Free Chips`,
    tooltip: $localize`:@@advertiser.free_chips_tooltip:Amount of free chips given to the player for who came from affiliate`,
  },
  free_spins: {
    label: $localize`:@@advertiser.free_spins:Free spins`,
    tooltip: $localize`:@@advertiser.free_spins_tooltip:Amount of spins and game in which they are given for the players who came from the affiliate`,
  },
  pay_cpa_on_verif: {
    label: $localize`:@@advertiser.pay_cpa_on_verif:Pay CPA on verification`,
    tooltip: $localize`:@@advertiser.pay_cpa_on_verif_tooltip:If selected, only phone verified users will be considered as new depositors`,
  },
  cpa_min_deposit: {
    label: $localize`:@@advertiser.cpa_min_deposit:CPA Min. deposit`,
    tooltip: $localize`:@@advertiser.cpa_min_deposit_tooltip:Minimum summary amount of deposits made by the user to be counted as a new depositor`,
  },
  no_late_conversions: {
    label: $localize`:@@advertiser.no_late_conversions:No Late Conversions`,
    tooltip: $localize`:@@advertiser.no_late_conversions_tooltip:If selected, the user will not be considered a new depositor, if the registration date was in a prior month`,
  },
  min_deposit_gte: {
    label: $localize`:@@advertiser.no_late_conversions:No Late Conversions`,
    tooltip: $localize`:@@advertiser.no_late_conversions_tooltip:If selected, the user will not be considered a new depositor, if the registration date was in a prior month`,
  },
};
